import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql, useStaticQuery } from 'gatsby';

import Link from '../Atoms/Link';
import generateWatchProjectImage from '../../utils/generateWatchProjectImage';
import Image from '../Atoms/Image';
import ArrowButton from '../Atoms/ArrowButton';

const magazineQuery = graphql`
  query {
    magazineArticles: allMagazine(limit: 3) {
      nodes {
        title
        middleImage
        category
        slug
        language
      }
    }
  }
`;

type StaticMagazineTeaserQuery = {
  magazineArticles: {
    nodes: {
      title: string;
      middleImage: string;
      category: string;
      slug: string;
      language: string;
    }[];
  };
};

const MagazineTeaser = () => {
  const { t } = useTranslation();
  const { magazineArticles } = useStaticQuery<StaticMagazineTeaserQuery>(magazineQuery);
  // const { language } = useContext(I18nextContext);

  // don't filter by language (show ES articles on EN)
  // const articles = magazineArticles.nodes.filter(article => article.language === language);
  const articles = magazineArticles.nodes;

  if (!articles.length) {
    return null;
  }

  return (
    <section className="py-12 px-4 lg:px-8 md:pl-12">
      <div className="max-w-screen-2xl w-full mx-auto grid lg:grid-cols-3">
        <div className="pt-24 pr-4 xl:pr-28">
          <h3 className="font-cirka font-light text-xl">{t('magazineTeaser.subtitle')}</h3>
          <h2 className="font-cirka text-4xl lg:text-5xl text-primary my-7">{t('magazineTeaser.title')}</h2>
          <Link to="/magazine" className="flex text-primary font-roboto font-light items-center mb-7 no-animation">
            <ArrowButton className="mr-2" />
            {t('magazineTeaser.button')}
          </Link>
        </div>
        <div
          className="lg:col-span-2 flex overflow-y-hidden overflow-x-scroll"
          style={{ WebkitOverflowScrolling: 'touch', scrollSnapType: 'x mandatory', scrollBehavior: 'smooth' }}
        >
          {articles.map((article, index) => (
            <Link to={`/magazine/${article.slug}`} key={`magazine-teaser-${article.title}`} className={`${index !== 0 ? 'ml-5' : ''} w-64 md:w-112 flex-shrink-0`}>
              <Image src={generateWatchProjectImage(article.middleImage, 'non-existing.jpg')} alt={article.title} className="h-80 md:h-112 object-cover" />
              <div className="py-4">
                <span className="font-roboto font-light text-lg text-primary">{article.category}</span>
                <h3 className="my-4 font-cirka text-2xl lg:text-4xl text-primary">{article.title}</h3>
                <ArrowButton className="mt-7" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MagazineTeaser;
